const NS = 'QuoteBrochureForm';
const CLS = 'quoteBrochureForm';
const BLK = '.' + CLS + '-';

import {utils} from '../../../../global/js/utils';

let _throttle = require('lodash/throttle');

export class QuoteBrochureForm {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.isSticky = this.$element.data('is-sticky') === true;

		if(this.isSticky) {
			let $clone;

			let removeClone = () => {
				if($clone) {
					$clone.remove();
					$clone = null;
					this.$element.css({
						visibility: 'visible',
					});
				}
			};

			let addClone = () => {
				$clone = this.$element.clone();
				$clone.attr('data-sticky-clone', 'true');
				$clone.insertBefore(this.$element);

				$clone.css({
					position: 'fixed',
					bottom: 0,
					left: 0,
					right: 0,
					zIndex: 50,
				});
				this.$element.css({
					visibility: 'hidden',
				});
			};

			let checkElement = () => {
				if(utils.checkBP('md', true)) {
					let windowBottom = window.scrollY + window.innerHeight;
					let elementBottom = this.$element.offset().top + this.$element.height();

					// If the non-cloned elemement offset bottom is above the bottom part of the window, remove the cloned element
					if(windowBottom > elementBottom) {
						removeClone();
					// Add back the cloned element assuming the cloned element is removed
					} else if(!$clone) {
						addClone();
					}
				} else {
					removeClone();
				}
			};

			$(window).on('scroll', _throttle(() => {
				checkElement();
			}, 50));

			$(window).on('resize', _throttle(() => {
				checkElement();
			}, 250));
		}
	}
}
